import { io, Socket } from 'socket.io-client';

// Use current domain for WebSocket when no VITE_SOCKET_URL is set
const SOCKET_URL = import.meta.env.VITE_SOCKET_URL || '';

let socket: Socket | null = null;

export function getSocket(): Socket | null {
  return socket;
}

export function connectSocket(token: string): Socket {
  if (socket?.connected) {
    return socket;
  }

  socket = io(SOCKET_URL, {
    auth: { token },
    transports: ['websocket', 'polling'],
    reconnection: true,
    reconnectionAttempts: 10,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 5000,
    timeout: 20000,
  });

  return socket;
}

export function disconnectSocket(): void {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
}

// Room subscriptions
export function subscribeToRooms(rooms: string[]): void {
  if (socket) {
    socket.emit('subscribe', rooms);
  }
}

export function unsubscribeFromRooms(rooms: string[]): void {
  if (socket) {
    socket.emit('unsubscribe', rooms);
  }
}

// Request current state
export function requestCurrentState(): void {
  if (socket) {
    socket.emit('state:request');
  }
}

// SOS actions via WebSocket
export function acknowledgeSOSViaSocket(sosId: string, notes?: string): void {
  if (socket) {
    socket.emit('sos:acknowledge', { sosId, notes });
  }
}

export type { Socket };

